import styled from 'styled-components';

interface ButtonProps {
  buttonColor: string;
}

export const ItemColor: { [key: string]: string } = {
  green: 'green',
  purple: 'purple',
};

export const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 0;
  background-color: ${({ theme }) => theme.menuBackground};

  @media (max-width: 700px) {
    justify-content: space-between;
  }
`;

export const MidContent = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  align-items: center;
  cursor: pointer;

  img {
    width: 5rem;
    height: auto;
    margin-left: 18vw;
    /* margin-left: 290px; */
  }

  svg {
    color: ${({ theme }) => theme.icon};
  }

  @media (max-width: 700px) {
    display: none;
  }
`;

export const RightContent = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 0 1rem 0 0.5rem;

  div {
    display: flex;
    align-items: center;
    margin-right: 45px;

    a {
      display: flex;
      align-items: center;
      margin-right: 2rem;

      p {
        width: 60px;
      }
      svg {
        color: ${({ theme }) => theme.icon};
      }
    }
  }

  > span {
    button {
      &:first-child {
        display: none;
      }
    }
  }

  @media (max-width: 500px) {
    div {
      button {
        display: none;
      }
    }
    > span {
      button {
        &:first-child {
          display: flex;
        }
      }
    }
  }

  @media (max-width: 450px) {
    width: calc(100% - 81px);

    div {
      margin-right: 0px;

      a {
        margin-right: 1rem;
      }
    }
  }

  @media (max-width: 350px) {
    div {
      a {
        svg {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
`;

export const Button = styled.button<ButtonProps>`
  padding: 0.2rem 0.5rem;
  margin: auto 0;
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  background-color: ${({ theme, buttonColor }) =>
    buttonColor === 'purple' ? theme.purple : theme.green};

  :hover {
    filter: brightness(1.1);
  }

  p {
    color: ${({ theme }) => theme.white};
    font-weight: bold;
    letter-spacing: 0.1rem;
    text-transform: uppercase;
    margin: 0;
  }

  .leave-league {
    width: 75px;

    @media (max-width: 500px) {
      width: auto;
    }
  }

  svg {
    color: ${({ theme }) => theme.white};
    margin-left: 0.5rem;
  }

  @media (max-width: 500px) {
    &:first-child {
      margin-bottom: 4px;
    }
  }

  @media (max-width: 350px) {
    padding: 0.2rem 0.25rem;

    p {
      font-size: 0.75rem;
    }

    svg {
      width: 15px;
      height: 15px;
    }
  }
`;
